import React from 'react';
import PropTypes from 'prop-types';
import { isSiteWithTelBanner } from '../../helpers';
import SimpleTooltip from '../Tooltip/SimpleTooltip';
import BackIcon from '../../assets/icons/flecha-grey.svg';
import ArrowBackBlack from '../../assets/icons/arrow-right-black.svg';
import { ContentLayout, ActionContain, StyledAction, Separator } from './styles';

const BackButton = ({
  device,
  useHistory,
  backgroundColor = 'lightGray',
  justifyContent = 'space-between',
  backButtonText = '',
  newItems = {},
  showDataLayer = () => {},
  withoutBackButton = false
}) => {
  const isDesktop = device === 'desktop';

  const onBackButtonPress = () => {
    if (showDataLayer) showDataLayer();
    return useHistory.go(-1);
  };

  return (
    <ContentLayout
      isDesktop={isDesktop}
      portalWithBanner={isSiteWithTelBanner}
      backgroundColor={backgroundColor}
      justifyContent={justifyContent}
      device={device}
    >
      {/* Se renderiza por default la funcionalidad del back Button: */}
      {!withoutBackButton && (
        <SimpleTooltip
          isMobile={!isDesktop}
          position='top-center'
          text={backButtonText}
          dataPanel='panel-tooltip-backButton'
        >
          <StyledAction
            icon={isDesktop ? BackIcon : ArrowBackBlack}
            backSize={`${isDesktop ? 16 : 22}px`}
            onClick={onBackButtonPress}
            data-panel='panel-icon-backButton'
          />
        </SimpleTooltip>
      )}

      {/* Se renderiza action para dispositivos desktop: */}
      {isDesktop &&
        newItems &&
        newItems.desktop &&
        newItems.desktop.map(item => {
          return (
            item.icon && (
              <ActionContain key={item.id} marginRight={item.marginRight} marginLeft={item.marginLeft}>
                {item.separator === 'preIcon' && (
                  <Separator separatorType={item.separator} spacing={item.gapSeparator} />
                )}
                <SimpleTooltip
                  isMobile={item.withoutTooltip}
                  position='top-center'
                  text={item.text}
                  dataPanel={`panel-tooltip-${item.id}`}
                  forceHide={item.disabledTooltip}
                >
                  <StyledAction
                    icon={item.icon}
                    backSize={item.backSize}
                    onClick={!item.disabled ? item.onClick : null}
                    data-panel={`panel-icon-${item.id}`}
                    disabled={item.disabled}
                  />
                  {item.children}
                </SimpleTooltip>
                {item.separator === 'postIcon' && (
                  <Separator separatorType={item.separator} spacing={item.gapSeparator} />
                )}
              </ActionContain>
            )
          );
        })}

      {/* Se renderiza action para dispositivos mobile y tablet: */}
      {!isDesktop && newItems && newItems.mobile && (
        <div className='container-mobileTablet'>
          {newItems.mobile.map(item => {
            return (
              item.icon && (
                <ActionContain key={item.id} marginRight={item.marginRight} marginLeft={item.marginLeft}>
                  {item.separator === 'preIcon' && (
                    <Separator separatorType={item.separator} spacing={item.gapSeparator} />
                  )}
                  <StyledAction
                    icon={item.icon}
                    backSize={item.backSize}
                    onClick={!item.disabled ? item.onClick : null}
                    data-panel={`panel-icon-${item.id}`}
                    disabled={item.disabled}
                  />
                  {item.children}
                  {item.separator === 'postIcon' && (
                    <Separator separatorType={item.separator} spacing={item.gapSeparator} />
                  )}
                </ActionContain>
              )
            );
          })}
        </div>
      )}
    </ContentLayout>
  );
};

BackButton.propTypes = {
  device: PropTypes.string.isRequired,
  useHistory: PropTypes.shape({ go: PropTypes.func }).isRequired
};

export default BackButton;
